import { append as append_1, sortBy, collect as collect_1, insertAt, map } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { createElement } from "react";
import * as react from "react";
import { SkillsModule_forageCropProbs, ProfessionModule_foragingProfessions, ProfessionModule_farmingProfessions, SkillsModule_professionUnlocked, SkillsModule_farmCropQualitiesFrom, Qualities_indexed, QualityModule_name } from "../Model/Skills.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { numberHash, uncurry3, stringHash, curry2, comparePrimitives, structuralHash, equals, createObj } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { Tabs as Tabs_1, Icon_error, Icon_warningWith, Icon_warning, handleEvent, Icon_specialCharm, Icon_luckBuff, labelWith, Icon_bearsKnowledge, Icon_foraging, Icon_farming, Icon_profession, percent, Icon_fertilizerName, lazyDetails, detailsSection, Icon_seed, Icon_itemId, Icon_NoText_processor, Icon_item, labeled, Icon_NoText_season, Icon_crop, labeledHidden, ofOption, Icon_NoText_vendor, percent2 } from "./Prelude.js";
import { mapIndexed, singleton as singleton_1, isEmpty, exists as exists_1, choose, ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { text as text_2, floatWithRange, natWithRange, checkboxWith, natWith, checkbox } from "./Input.js";
import { AppMessage, PresetsMessage, CropAmountMessage, MultipliersMessage, SkillMessage, SkillsMessage, CropFiltersMessage, GameVariablesMessage, SettingsMessage, SelectionsMessage, StateMessage, UIMessage, CropTabMessage, CustomMessage$2, ProfitMessage } from "../Update.js";
import { iterate, sortBy as sortBy_1, forAll, filter, exists, toArray, sortWith, collect, sortByDescending, map as map_1, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { Array_distinct, distinct, countBy } from "../fable_modules/fable-library-js.4.29.0/Seq2.js";
import { Column_create, Column_withDisabled, tableFromColumns, Column_createWith, Column_valueSortable, Column_sortable, Column_markAsKey, tableFromColumnsWithRowDisable, Column_valueOptSortable, Column_sortableOpt, Column_withSelect } from "./Table.js";
import { FSharpMap__get_Item, find, FSharpMap__TryFind, FSharpMap__ContainsKey } from "../fable_modules/fable-library-js.4.29.0/Map.js";
import { ofArray as ofArray_1, contains, FSharpSet__Contains } from "../fable_modules/fable-library-js.4.29.0/Set.js";
import { confirmAction, toggleEditWith, toggleEdit } from "./Dialog.js";
import { bind, toArray as toArray_1, map as map_2, defaultArg } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { getItemFromDict } from "../fable_modules/fable-library-js.4.29.0/MapUtil.js";
import { Common_lazyView2 } from "../fable_modules/Fable.Elmish.React.5.0.0/common.fs.js";
import { SettingsTab_$reflection, PresetModule_hasId, OpenDetails, SeedStrategy_$reflection, Option_noneMaxCompareBy, Util_refMemo } from "../Types.js";
import { Table_tryFind } from "../Model/Prelude.js";
import { Price_fertilizerMinPrice, Price_fertilizerMinVendorAndPrice, fertilizerCost, seedPriceValueFromVendor, customSellPriceValue, Price_seedMinPrice, Price_seedMinVendorAndPrice, canMakeEnoughSeeds } from "../Query.js";
import { Location_$reflection, Game_processorUnlocked, GameDataModule_product, Game_itemPrice, Game_productPrice, Game_productNormalizedPrice, Game_growthTime, Game_cropIsInSeason } from "../Model/Game.js";
import { ToolLevelModule_name, Date$, SeasonsModule_contains, SeasonModule_name, CropModule_giant, CropModule_regrows, CropModule_growsInSeasons, CropModule_items, ForageCropModule_seedRecipeUnlocked, CropModule_isForage, CropModule_makesOwnSeeds, CropModule_canGetOwnSeedsFromSeedMaker, ForageCropModule_seedItem, FarmCropModule_items, SeasonsModule_setOrder, CropModule_seasons, CropModule_growsInSeason, CropModule_regrowTime, CropModule_name, CropModule_seed } from "../Model/Crops.js";
import { getUnionCases, makeUnion, getCaseName, getEnumName, enum_type, int32_type, getEnumValues } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { options } from "./Select.js";
import { Option_defaultOrMap, Table_tryFind as Table_tryFind_1 } from "../Model/Prelude.js";
import { max, min } from "../fable_modules/fable-library-js.4.29.0/Double.js";
import { SkillsModule_farmCropProbsWith } from "../Model/Skills.js";
import { rangeDouble } from "../fable_modules/fable-library-js.4.29.0/Range.js";
import { defaultSettings, loadSaveGame } from "../Data.js";

export function cropQualities(qualities) {
    let elems;
    const mapQualities = (content) => {
        const children = map((tupledArg) => {
            let str;
            const quality = tupledArg[0] | 0;
            const prob = tupledArg[1];
            return createElement("div", {
                className: (str = QualityModule_name(quality), str.toLocaleLowerCase()),
                style: {
                    flexGrow: prob,
                },
                children: content(quality)(prob),
            });
        }, Qualities_indexed(qualities));
        return createElement("div", {
            children: reactApi.Children.toArray(Array.from(children)),
        });
    };
    return createElement("div", createObj(ofArray([["className", "crop-qualities"], (elems = [mapQualities((_arg) => ((_arg_1) => defaultOf())), mapQualities((quality_2) => ((prob_1) => {
        const xs_2 = [createElement("span", {
            className: "label-hidden",
            children: QualityModule_name(quality_2),
        }), createElement("span", {
            children: [(prob_1 === 0) ? "" : percent2(prob_1)],
        })];
        return react.createElement(react.Fragment, {}, ...xs_2);
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function payForFertilizerSettings(profit, dispatch) {
    const xs_1 = [checkbox("Pay for Fertilizer", profit.PayForFertilizer, (arg) => {
        dispatch(new ProfitMessage(1, [arg]));
    }), createElement("span", createObj(toList(delay(() => append(!profit.PayForFertilizer ? singleton(["className", "disabled"]) : empty(), delay(() => {
        let elems;
        return singleton((elems = [checkbox("Pay for Destroyed Fertilizer", profit.PayForDestroyedFertilizer, (arg_1) => {
            dispatch(new ProfitMessage(2, [arg_1]));
        })], ["children", reactApi.Children.toArray(Array.from(elems))]));
    }))))))];
    return react.createElement(react.Fragment, {}, ...xs_1);
}

export function viewPrice(price) {
    const xs = toList(delay(() => {
        if (price == null) {
            return singleton("???");
        }
        else {
            const source = price[0];
            const price_1 = price[1];
            return append(singleton(price_1.toString()), delay(() => {
                const matchValue = source;
                return (matchValue.tag === 1) ? singleton(defaultOf()) : singleton(Icon_NoText_vendor(matchValue.fields[0]));
            }));
        }
    }));
    return react.createElement(react.Fragment, {}, ...xs);
}

function sortKeysByHighestCount(table) {
    return Array.from(map_1((tuple_1) => tuple_1[0], sortByDescending((tuple) => tuple[1], countBy((x) => x, collect((arg00$0040_1) => arg00$0040_1.fields[0].keys(), table.fields[0].values()), {
        Equals: equals,
        GetHashCode: structuralHash,
    }), {
        Compare: comparePrimitives,
    })));
}

function customColumn(viewValue, editValue, defaultValue, viewKey, key, selection, dispatch) {
    return Column_withSelect((key_6) => {
        if (FSharpMap__ContainsKey(selection.Values, key_6)) {
            return FSharpSet__Contains(selection.Selected, key_6);
        }
        else {
            return undefined;
        }
    }, (arg_2) => {
        dispatch(new CustomMessage$2(3, [arg_2]));
    }, Column_sortableOpt("Custom", (item) => {
        let xs, f1, f;
        const key_1 = key(item);
        const value_1 = FSharpMap__TryFind(selection.Values, key_1);
        const xs_2 = [ofOption(viewValue, value_1), toggleEdit((xs = ["Custom Price For ", viewKey(key_1)], react.createElement(react.Fragment, {}, ...xs)), defaultArg(value_1, defaultValue), (f1 = ((f = ((value_1 != null) ? ((tupledArg) => (new CustomMessage$2(1, [tupledArg[0], tupledArg[1]]))) : ((tupledArg_1) => (new CustomMessage$2(0, [tupledArg_1[0], tupledArg_1[1]])))), (b) => f([key_1, b]))), (arg) => {
            dispatch(f1(arg));
        }), (close, v, setValue) => {
            const children = toList(delay(() => append(singleton(editValue(v, setValue)), delay(() => ((value_1 != null) ? singleton(createElement("button", {
                className: "button",
                onClick: (_arg) => {
                    dispatch(new CustomMessage$2(2, [key_1]));
                    close();
                },
                children: "Delete",
            })) : empty())))));
            return createElement("div", {
                children: reactApi.Children.toArray(Array.from(children)),
            });
        })];
        return react.createElement(react.Fragment, {}, ...xs_2);
    }, (arg_1) => FSharpMap__TryFind(selection.Values, key(arg_1))));
}

function customPriceColumn(viewKey, key, selection, dispatch) {
    return customColumn((n) => n.toString(), (value_2, setValue) => labeledHidden("Price", natWith(3 + "em", undefined, undefined, value_2, setValue)), 0, viewKey, key, selection, dispatch);
}

function priceColumns(prices, selected, custom, priceValue, icon, vendors, selectMsg, customMsg, dispatch) {
    const array_1 = map((vendor) => Column_withSelect((key) => {
        let arg10$0040_1;
        if ((arg10$0040_1 = getItemFromDict(prices.fields[0], key), arg10$0040_1.fields[0].has(vendor))) {
            return contains(vendor, find(key, selected));
        }
        else {
            return undefined;
        }
    }, (arg) => {
        dispatch(selectMsg([vendor, arg]));
    }, Column_valueOptSortable(Icon_NoText_vendor(vendor), curry2(priceValue)(vendor), (option) => ofOption((n) => n.toString(), option))), vendors);
    const value_2 = customPriceColumn(icon, (x) => x, custom, (arg_1) => {
        dispatch(customMsg(arg_1));
    });
    const array_2 = array_1;
    return insertAt(array_2.length, value_2, array_2);
}

function lazyTable(table, data, settings, sort, items, dispatch) {
    return Common_lazyView2((tupledArg, dispatch_1) => table(tupledArg[0], tupledArg[1], tupledArg[2], tupledArg[3], dispatch_1))([data, settings, sort, items])(dispatch);
}

export const Crops_seedVendors = Util_refMemo((data) => sortKeysByHighestCount(data.SeedPrices));

export const Crops_processors = Util_refMemo((data) => Array.from(sortWith((a, b) => Option_noneMaxCompareBy((key) => Table_tryFind(key, data.ProcessorUnlockLevel), a, b), distinct(append(["Preserves Jar", "Keg", "Seed Maker"], collect((arg00$0040) => arg00$0040.fields[0].keys(), data.Products.fields[0].values())), {
    Equals: (x, y) => (x === y),
    GetHashCode: stringHash,
}))));

export function Crops_table(data, settings, cropSort_, cropSort__1, crops, dispatch) {
    const cropSort = [cropSort_, cropSort__1];
    return tableFromColumnsWithRowDisable((crop) => !(canMakeEnoughSeeds(data, settings, crop) && Game_cropIsInSeason(settings.Game, crop)), CropModule_seed, cropSort[0], cropSort[1], (arg_5) => {
        dispatch(new StateMessage(1, [new UIMessage(5, [new CropTabMessage(1, [arg_5])])]));
    }, [Column_markAsKey(Column_withSelect((arg_6) => FSharpSet__Contains(settings.Selected.Crops, arg_6), (arg_2) => {
        dispatch(new StateMessage(0, [new SettingsMessage(2, [new SelectionsMessage(0, [arg_2])])]));
    }, Column_sortable("Crop", (_arg) => Icon_crop(data, _arg), (_arg_2) => CropModule_name((key) => getItemFromDict(data.Items.fields[0], key), _arg_2)))), Column_sortableOpt("Seed Price", (arg_8) => viewPrice(Price_seedMinVendorAndPrice(data, settings, CropModule_seed(arg_8))), (arg_9) => Price_seedMinPrice(data, settings, CropModule_seed(arg_9))), Column_valueSortable("Days", (crop_1) => Game_growthTime(settings.Game, undefined, crop_1), (n) => n.toString()), Column_valueOptSortable("Regrow", CropModule_regrowTime, (option) => ofOption((n_3) => n_3.toString(), option)), Column_createWith("Seasons", (crop_2) => {
        let elems;
        return createElement("span", createObj(ofArray([["className", "seasons"], (elems = map((season) => {
            if (CropModule_growsInSeason(season, crop_2)) {
                return Icon_NoText_season(season);
            }
            else {
                return createElement("div", {});
            }
        }, getEnumValues(enum_type("StardewValleyStonks.Season", int32_type, [["Spring", 0], ["Summer", 1], ["Fall", 2], ["Winter", 3]]))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }, uncurry3((ascending) => {
        const compare = (c1, c2) => {
            const matchValue = CropModule_seasons(c1) | 0;
            const matchValue_1 = CropModule_seasons(c2) | 0;
            if (matchValue === 0) {
                if (matchValue_1 === 0) {
                    return 0;
                }
                else {
                    return 1;
                }
            }
            else if (matchValue_1 === 0) {
                return -1;
            }
            else {
                return SeasonsModule_setOrder(matchValue, matchValue_1) | 0;
            }
        };
        return ascending ? ((a) => ((b) => compare(a, b))) : ((a_1) => ((b_1) => compare(b_1, a_1)));
    }))], crops);
}

export function Crops_products(data, settings, cropTab, crops, dispatch) {
    const cropTabDispatch = (arg_1) => {
        dispatch(new StateMessage(1, [new UIMessage(5, [arg_1])]));
    };
    const selectDispatch = (arg_3) => {
        dispatch(new StateMessage(0, [new SettingsMessage(2, [arg_3])]));
    };
    const nonForageItems = collect_1((_arg) => {
        if (_arg.tag === 1) {
            return new Uint32Array([]);
        }
        else {
            return FarmCropModule_items(_arg.fields[0]);
        }
    }, crops, Uint32Array);
    const items = sortBy((arg_4) => getItemFromDict(data.Items.fields[0], arg_4).Name, Array_distinct(append_1(nonForageItems, collect_1((_arg_1) => {
        if (_arg_1.tag === 1) {
            const crop_1 = _arg_1.fields[0];
            return insertAt(0, ForageCropModule_seedItem(crop_1), crop_1.Foragables, Uint32Array);
        }
        else {
            return new Uint32Array([]);
        }
    }, crops, Uint32Array), Uint32Array), {
        Equals: (x, y) => (x === y),
        GetHashCode: numberHash,
    }), {
        Compare: comparePrimitives,
    });
    const nonForageItems_1 = ofArray_1(nonForageItems, {
        Compare: comparePrimitives,
    });
    const productQuality = cropTab.ProductQuality | 0;
    const normalizedPrices = cropTab.NormalizeProductPrices;
    const xs_2 = toList(delay(() => {
        let elems;
        return append(singleton(createElement("div", createObj(ofArray([["className", "settings-group"], (elems = [labeled("Show Prices for Quality", options(4 + "em", (arg_6) => getEnumName(enum_type("StardewValleyStonks.Quality", int32_type, [["Normal", 0], ["Silver", 1], ["Gold", 2], ["Iridium", 3]]), arg_6), getEnumValues(enum_type("StardewValleyStonks.Quality", int32_type, [["Normal", 0], ["Silver", 1], ["Gold", 2], ["Iridium", 3]])), productQuality, (arg_5) => {
            cropTabDispatch(new CropTabMessage(4, [arg_5]));
        })), checkbox("Show Normalized Prices", normalizedPrices, (arg_7) => {
            cropTabDispatch(new CropTabMessage(5, [arg_7]));
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let items_1, tupledArg;
            const price = normalizedPrices ? ((product) => Game_productNormalizedPrice(data, settings.Game, productQuality, product)) : ((arg_8) => Game_productPrice(data, settings.Game, productQuality, arg_8));
            return singleton((items_1 = map((key_5) => getItemFromDict(data.Items.fields[0], key_5), items), (tupledArg = cropTab.ProductSort, tableFromColumns((_arg_5) => _arg_5.Id, tupledArg[0], tupledArg[1], (arg_9) => {
                cropTabDispatch(new CropTabMessage(2, [arg_9]));
            }, toArray(delay(() => append(singleton(Column_markAsKey(Column_sortable("Item", Icon_item, (_arg_6) => _arg_6.Name))), delay(() => append(singleton(Column_withSelect((arg_10) => FSharpSet__Contains(settings.Selected.SellRaw, arg_10), (arg_11) => {
                selectDispatch(new SelectionsMessage(5, [arg_11]));
            }, Column_valueSortable("Raw", (item_1) => Game_itemPrice(settings.Game, !contains(item_1.Id, nonForageItems_1), item_1, productQuality), (n) => n.toString()))), delay(() => append(map((processor) => {
                const column_3 = Column_withSelect((item_3) => {
                    if (GameDataModule_product(data, processor, item_3) != null) {
                        return FSharpSet__Contains(FSharpMap__get_Item(settings.Selected.Products, item_3), processor);
                    }
                    else {
                        return undefined;
                    }
                }, (arg_14) => {
                    let tupledArg_1;
                    selectDispatch((tupledArg_1 = [processor, arg_14], new SelectionsMessage(6, [tupledArg_1[0], tupledArg_1[1]])));
                }, Column_valueOptSortable(Icon_NoText_processor(processor), (arg_13) => map_2(price, GameDataModule_product(data, processor, arg_13.Id)), (option_1) => ofOption((x_3) => x_3, option_1)));
                return Column_withDisabled(!Game_processorUnlocked(data, settings.Game, processor), column_3);
            }, Crops_processors(data)), delay(() => singleton(customColumn((arg_15) => {
                let n_3;
                const tupledArg_2 = arg_15;
                n_3 = customSellPriceValue(productQuality, tupledArg_2[0], tupledArg_2[1]);
                return n_3.toString();
            }, (tupledArg_3, setState) => {
                const price_2 = tupledArg_3[0];
                const preserveQuality_1 = tupledArg_3[1];
                const xs_1 = [labeledHidden("Price", natWith(3 + "em", undefined, undefined, price_2, (price_3) => {
                    setState([price_3, preserveQuality_1]);
                })), checkbox("Scale with quality", preserveQuality_1, (preserveQuality_2) => {
                    setState([price_2, preserveQuality_2]);
                })];
                return react.createElement(react.Fragment, {}, ...xs_1);
            }, [0, false], (itemId) => Icon_itemId(data, itemId), (_arg_8) => _arg_8.Id, settings.Selected.CustomSellPrices, (arg_16) => {
                selectDispatch(new SelectionsMessage(12, [arg_16]));
            })))))))))), items_1))));
        }));
    }));
    return react.createElement(react.Fragment, {}, ...xs_2);
}

export function Crops_seeds(data, settings, seedSort_, seedSort__1, crops, dispatch) {
    let elems, items;
    const seedSort = [seedSort_, seedSort__1];
    const settingsDispatch = (arg) => {
        dispatch(new StateMessage(0, [arg]));
    };
    const selectDispatch = (arg_1) => {
        settingsDispatch(new SettingsMessage(2, [arg_1]));
    };
    const xs_1 = [createElement("div", createObj(ofArray([["className", "settings-group"], (elems = [labeled("Seed Strategy", options(5 + "em", getCaseName, map((x_1) => makeUnion(x_1, []), getUnionCases(SeedStrategy_$reflection())), settings.Profit.SeedStrategy, (arg_3) => {
        settingsDispatch(new SettingsMessage(1, [new ProfitMessage(0, [arg_3])]));
    })), checkbox("Joja Membership", settings.Game.JojaMembership, (arg_6) => {
        settingsDispatch(new SettingsMessage(0, [new GameVariablesMessage(6, [arg_6])]));
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), (items = map(CropModule_seed, crops, Uint32Array), tableFromColumns((x_2) => x_2, seedSort[0], seedSort[1], (arg_9) => {
        dispatch(new StateMessage(1, [new UIMessage(5, [new CropTabMessage(3, [arg_9])])]));
    }, toArray(delay(() => append(singleton(Column_markAsKey(Column_sortable("Seed", (seed) => Icon_seed(data, seed), (arg_11) => getItemFromDict(data.Items.fields[0], arg_11 * 1).Name))), delay(() => append(priceColumns(data.SeedPrices, settings.Selected.SeedPrices, settings.Selected.CustomSeedPrices, (vendor, seed_3) => seedPriceValueFromVendor(data, settings, vendor, seed_3), (seed_4) => Icon_seed(data, seed_4), Crops_seedVendors(data), (tupledArg) => (new SelectionsMessage(1, [tupledArg[0], tupledArg[1]])), (Item_11) => (new SelectionsMessage(11, [Item_11])), selectDispatch), delay(() => {
        let column_2, x_3;
        return append(singleton((column_2 = Column_withSelect((seed_5) => {
            if (CropModule_canGetOwnSeedsFromSeedMaker((key_6) => getItemFromDict(data.Items.fields[0], key_6), getItemFromDict(data.Crops.fields[0], seed_5))) {
                return FSharpSet__Contains(settings.Selected.UseSeedMaker, seed_5);
            }
            else {
                return undefined;
            }
        }, (arg_12) => {
            selectDispatch(new SelectionsMessage(8, [arg_12]));
        }, Column_create(Icon_NoText_processor("Seed Maker"), (x_3 = defaultOf(), (arg10$0040_1) => x_3))), Column_withDisabled(!Game_processorUnlocked(data, settings.Game, "Seed Maker"), column_2))), delay(() => {
            let x_5;
            return append(singleton(Column_withSelect((seed_6) => {
                if (CropModule_makesOwnSeeds(getItemFromDict(data.Crops.fields[0], seed_6))) {
                    return FSharpSet__Contains(settings.Selected.UseHarvestedSeeds, seed_6);
                }
                else {
                    return undefined;
                }
            }, (arg_13) => {
                selectDispatch(new SelectionsMessage(7, [arg_13]));
            }, Column_create("Raw", (x_5 = defaultOf(), (arg10$0040_4) => x_5)))), delay(() => {
                let column_5, x_7;
                return singleton((column_5 = Column_withSelect((seed_7) => {
                    if (CropModule_isForage(getItemFromDict(data.Crops.fields[0], seed_7))) {
                        return FSharpSet__Contains(settings.Selected.UseForageSeeds, seed_7);
                    }
                    else {
                        return undefined;
                    }
                }, (arg_14) => {
                    selectDispatch(new SelectionsMessage(9, [arg_14]));
                }, Column_create("Forage", (x_7 = defaultOf(), (arg10$0040_6) => x_7))), Column_withDisabled(!exists((_arg_10) => {
                    if (_arg_10.tag === 0) {
                        return false;
                    }
                    else {
                        return ForageCropModule_seedRecipeUnlocked(settings.Game.Skills, _arg_10.fields[0]);
                    }
                }, crops), column_5)));
            }));
        }));
    })))))), items))];
    return react.createElement(react.Fragment, {}, ...xs_1);
}

function Crops_filteredCrops(app) {
    let itemNameMatchesSearch;
    const data = app.Data;
    const patternInput = app.State;
    const filters = patternInput[1].CropTab.Filters;
    const optionFilter = (projection, filterValue) => map_2((value) => ((arg) => equals(value, projection(arg))), filterValue);
    const filters_1 = choose((x) => x, ofArray([(filters.ItemNameSearch === "") ? undefined : ((itemNameMatchesSearch = ((name) => {
        let str_3;
        const str = getItemFromDict(data.Items.fields[0], name).Name;
        str_3 = str.toLocaleLowerCase();
        const text = filters.ItemNameSearch.toLocaleLowerCase();
        return str_3.indexOf(text) >= 0;
    }), (crop) => (itemNameMatchesSearch(CropModule_seed(crop) * 1) ? true : exists(itemNameMatchesSearch, CropModule_items(crop))))), filters.InSeason ? ((crop_1) => Game_cropIsInSeason(patternInput[0].Game, crop_1)) : ((_arg_3) => CropModule_growsInSeasons(filters.Seasons, _arg_3)), optionFilter(CropModule_regrows, filters.Regrows), optionFilter(CropModule_giant, filters.Giant), optionFilter(CropModule_isForage, filters.Forage)]));
    return Array.from(filter((crop_2) => forAll((predicate) => predicate(crop_2), filters_1), data.Crops.fields[0].values()));
}

export function Crops_sortKey(data) {
    return (_arg_1) => CropModule_name((key) => getItemFromDict(data.Items.fields[0], key), _arg_1);
}

function Crops_selectFilter(name, value, dispatch) {
    return labeled(name, options(2 + "em", (_arg) => ((_arg == null) ? "Any" : (_arg ? "Yes" : "No")), [true, false, undefined], value, dispatch));
}

export function Crops_cropFilter(filters, dispatch) {
    let children, children_2;
    const xs_3 = [labeledHidden("Search", createElement("input", {
        className: "input-box",
        placeholder: "Search...",
        type: "search",
        value: filters.ItemNameSearch,
        onChange: (ev) => {
            dispatch(new CropFiltersMessage(0, [ev.target.value]));
        },
    })), (children = toList(delay(() => append(singleton(checkbox("In Season", filters.InSeason, (arg_1) => {
        dispatch(new CropFiltersMessage(1, [arg_1]));
    })), delay(() => map((season_5) => createElement("span", createObj(toList(delay(() => append(filters.InSeason ? singleton(["className", "disabled"]) : empty(), delay(() => {
        let elems, f1_3, f1_2, season;
        return singleton((elems = [checkbox(SeasonModule_name(season_5), SeasonsModule_contains(season_5, filters.Seasons), (f1_3 = ((f1_2 = ((season = (season_5 | 0), (selected) => (selected ? (filters.Seasons | (1 << season)) : (filters.Seasons & ~(1 << season))))), (arg_2) => (new CropFiltersMessage(2, [f1_2(arg_2)])))), (arg_3) => {
            dispatch(f1_3(arg_3));
        }))], ["children", reactApi.Children.toArray(Array.from(elems))]));
    })))))), getEnumValues(enum_type("StardewValleyStonks.Season", int32_type, [["Spring", 0], ["Summer", 1], ["Fall", 2], ["Winter", 3]]))))))), createElement("div", {
        children: reactApi.Children.toArray(Array.from(children)),
    })), (children_2 = ofArray([Crops_selectFilter("Regrows", filters.Regrows, (arg_4) => {
        dispatch(new CropFiltersMessage(3, [arg_4]));
    }), Crops_selectFilter("Giant", filters.Giant, (arg_5) => {
        dispatch(new CropFiltersMessage(4, [arg_5]));
    }), Crops_selectFilter("Forage", filters.Forage, (arg_6) => {
        dispatch(new CropFiltersMessage(5, [arg_6]));
    }), createElement("button", {
        className: "button",
        onClick: (_arg) => {
            dispatch(new CropFiltersMessage(6, []));
        },
        children: "Clear",
    })]), createElement("div", {
        children: reactApi.Children.toArray(Array.from(children_2)),
    }))];
    return react.createElement(react.Fragment, {}, ...xs_3);
}

export function Crops_tab(app, dispatch) {
    const data = app.Data;
    const patternInput = app.State;
    const ui = patternInput[1];
    const settings = patternInput[0];
    const cropTab = ui.CropTab;
    const uiDispatch = (arg) => {
        dispatch(new StateMessage(1, [arg]));
    };
    let crops;
    const array = Crops_filteredCrops(app);
    crops = sortBy(Crops_sortKey(data), array, {
        Compare: comparePrimitives,
    });
    const xs = [detailsSection(ui.OpenDetails, new OpenDetails(0, []), "Filters", Crops_cropFilter(cropTab.Filters, (arg_2) => {
        uiDispatch(new UIMessage(5, [new CropTabMessage(0, [arg_2])]));
    }), uiDispatch), lazyDetails(ui.OpenDetails, new OpenDetails(1, []), "Crops", () => lazyTable((data_1, settings_1, tupledArg, crops_1, dispatch_1) => Crops_table(data_1, settings_1, tupledArg[0], tupledArg[1], crops_1, dispatch_1), data, settings, cropTab.CropSort, crops, dispatch), uiDispatch), lazyDetails(ui.OpenDetails, new OpenDetails(2, []), "Products", () => lazyTable(Crops_products, data, settings, cropTab, crops, dispatch), uiDispatch), lazyDetails(ui.OpenDetails, new OpenDetails(3, []), "Seeds", () => lazyTable((data_3, settings_3, tupledArg_1, crops_3, dispatch_3) => Crops_seeds(data_3, settings_3, tupledArg_1[0], tupledArg_1[1], crops_3, dispatch_3), data, settings, cropTab.SeedSort, crops, dispatch), uiDispatch)];
    return react.createElement(react.Fragment, {}, ...xs);
}

export const Fertilizers_fertilizerVendors = Util_refMemo((data) => sortKeysByHighestCount(data.FertilizerPrices));

export function Fertilizers_table(data, settings, fertSort_, fertSort__1, fertilizers, dispatch) {
    let elems;
    const fertSort = [fertSort_, fertSort__1];
    const selectDispatch = (arg_2) => {
        dispatch(new StateMessage(0, [new SettingsMessage(2, [arg_2])]));
    };
    const xs_1 = [createElement("div", createObj(ofArray([["className", "settings-group"], (elems = [checkbox("Allow No Fertilizer", settings.Selected.NoFertilizer, (arg_3) => {
        selectDispatch(new SelectionsMessage(2, [arg_3]));
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), tableFromColumnsWithRowDisable((arg_5) => (fertilizerCost(data, settings, arg_5.Name) == null), (_arg_1) => _arg_1.Name, fertSort[0], fertSort[1], (arg_6) => {
        dispatch(new StateMessage(1, [new UIMessage(6, [arg_6])]));
    }, [Column_markAsKey(Column_withSelect((arg_7) => FSharpSet__Contains(settings.Selected.Fertilizers, arg_7), (arg_8) => {
        selectDispatch(new SelectionsMessage(3, [arg_8]));
    }, Column_valueSortable("Fertilizer", (fertilizer_1) => fertilizer_1.Name, Icon_fertilizerName))), Column_sortableOpt("Price", (arg_10) => viewPrice(Price_fertilizerMinVendorAndPrice(data, settings, arg_10.Name)), (arg_11) => Price_fertilizerMinPrice(data, settings, arg_11.Name)), Column_valueSortable("Growth Rate", (_arg_4) => _arg_4.Speed, percent), Column_valueSortable("Crop Qualities", (_arg_5) => _arg_5.Quality, (fertQuality) => cropQualities(SkillsModule_farmCropQualitiesFrom(fertQuality, settings.Game.Skills)))], fertilizers)];
    return react.createElement(react.Fragment, {}, ...xs_1);
}

export function Fertilizers_prices(data, settings, fertPriceSort_, fertPriceSort__1, fertilizers, dispatch) {
    const fertPriceSort = [fertPriceSort_, fertPriceSort__1];
    const dispatch_1 = (arg_1) => {
        dispatch(new StateMessage(0, [arg_1]));
    };
    const fertilizers_1 = map((_arg) => _arg.Name, fertilizers);
    const xs_1 = [createElement("div", {
        className: "settings-group",
        children: payForFertilizerSettings(settings.Profit, (arg_3) => {
            dispatch_1(new SettingsMessage(1, [arg_3]));
        }),
    }), tableFromColumns((x) => x, fertPriceSort[0], fertPriceSort[1], (arg_4) => {
        dispatch(new StateMessage(1, [new UIMessage(7, [arg_4])]));
    }, toArray(delay(() => append(singleton(Column_markAsKey(Column_valueSortable("Fertilizer", (x_1) => x_1, Icon_fertilizerName))), delay(() => priceColumns(data.FertilizerPrices, settings.Selected.FertilizerPrices, settings.Selected.CustomFertilizerPrices, (vendor, arg_5) => Table_tryFind_1(vendor, getItemFromDict(data.FertilizerPrices.fields[0], arg_5)), Icon_fertilizerName, Fertilizers_fertilizerVendors(data), (tupledArg) => (new SelectionsMessage(4, [tupledArg[0], tupledArg[1]])), (Item_7) => (new SelectionsMessage(10, [Item_7])), (arg_2) => {
        dispatch_1(new SettingsMessage(2, [arg_2]));
    }))))), fertilizers_1)];
    return react.createElement(react.Fragment, {}, ...xs_1);
}

export function Fertilizers_tab(app, dispatch) {
    const data = app.Data;
    const patternInput = app.State;
    const ui = patternInput[1];
    const settings = patternInput[0];
    const uiDispatch = (arg) => {
        dispatch(new StateMessage(1, [arg]));
    };
    const fertilizers = Array.from(sortBy_1((_arg_1) => _arg_1.Name, data.Fertilizers.fields[0].values(), {
        Compare: comparePrimitives,
    }));
    const xs = [lazyDetails(ui.OpenDetails, new OpenDetails(4, []), "Fertilizers", () => lazyTable((data_1, settings_1, tupledArg, fertilizers_1, dispatch_1) => Fertilizers_table(data_1, settings_1, tupledArg[0], tupledArg[1], fertilizers_1, dispatch_1), data, settings, ui.FertilizerSort, fertilizers, dispatch), uiDispatch), lazyDetails(ui.OpenDetails, new OpenDetails(5, []), "Prices", () => lazyTable((data_2, settings_2, tupledArg_1, fertilizers_2, dispatch_2) => Fertilizers_prices(data_2, settings_2, tupledArg_1[0], tupledArg_1[1], fertilizers_2, dispatch_2), data, settings, ui.FertilizerPriceSort, fertilizers, dispatch), uiDispatch)];
    return react.createElement(react.Fragment, {}, ...xs);
}

function Settings_date(label, otherDate, clamp, date, dispatch) {
    let elems;
    const clamp_1 = (season, day) => {
        if (season === otherDate.Season) {
            return clamp(otherDate.Day, day);
        }
        else {
            return day;
        }
    };
    return createElement("div", createObj(ofArray([["className", "date"], (elems = [labeled(`${label} Date`, defaultOf()), labeledHidden(`${label} Season`, options(4 + "em", (arg) => getEnumName(enum_type("StardewValleyStonks.Season", int32_type, [["Spring", 0], ["Summer", 1], ["Fall", 2], ["Winter", 3]]), arg), getEnumValues(enum_type("StardewValleyStonks.Season", int32_type, [["Spring", 0], ["Summer", 1], ["Fall", 2], ["Winter", 3]])), date.Season, (season_1) => {
        dispatch(new Date$(season_1, clamp_1(season_1, date.Day)));
    })), labeledHidden(`${label} Day`, natWith(1.5 + "em", clamp_1(date.Season, 1), clamp_1(date.Season, 28), date.Day, (day_1) => {
        dispatch(new Date$(date.Season, day_1));
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function Settings_dates(startDate, endDate, dispatch) {
    const xs = [Settings_date("Start", endDate, min, startDate, (arg) => {
        dispatch(new GameVariablesMessage(0, [arg]));
    }), Settings_date("End", startDate, max, endDate, (arg_1) => {
        dispatch(new GameVariablesMessage(1, [arg_1]));
    })];
    return react.createElement(react.Fragment, {}, ...xs);
}

export function Settings_profession(skills, profession, dispatch) {
    return createElement("div", createObj(toList(delay(() => append(!SkillsModule_professionUnlocked(profession, skills) ? singleton(["className", "disabled"]) : empty(), delay(() => {
        let elems;
        return singleton((elems = [checkboxWith(Icon_profession(profession), FSharpSet__Contains(skills.Professions, profession), (arg) => {
            let tupledArg;
            dispatch((tupledArg = [profession, arg], new SkillsMessage(2, [tupledArg[0], tupledArg[1]])));
        })], ["children", reactApi.Children.toArray(Array.from(elems))]));
    }))))));
}

export function Settings_skillBuffLevel(skill, dispatch) {
    let elems;
    return createElement("div", createObj(ofArray([["className", "skill-level"], (elems = [natWithRange("Level", 1.5 + "em", 0, 10, skill.Level, (arg) => {
        dispatch(new SkillMessage(0, [arg]));
    }), labeled("Buff", natWith(1.5 + "em", undefined, 999, skill.Buff, (arg_1) => {
        dispatch(new SkillMessage(1, [arg_1]));
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function Settings_skill(skills, skill, professions, qualities, icon, levelMsg, dispatch) {
    let elems_1, elems;
    return createElement("div", createObj(ofArray([["className", "skill"], (elems_1 = [icon, Settings_skillBuffLevel(skill, (arg) => {
        dispatch(levelMsg(arg));
    }), cropQualities(qualities(skills)), createElement("div", createObj(ofArray([["className", "professions"], (elems = map((prof) => Settings_profession(skills, prof, dispatch), professions), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function Settings_farming(skills, dispatch) {
    return Settings_skill(skills, skills.Farming, ProfessionModule_farmingProfessions, (skills_1) => SkillsModule_farmCropProbsWith(undefined, skills_1), Icon_farming, (Item) => (new SkillsMessage(0, [Item])), dispatch);
}

export function Settings_foraging(skills, dispatch) {
    return Settings_skill(skills, skills.Foraging, ProfessionModule_foragingProfessions, SkillsModule_forageCropProbs, Icon_foraging, (Item) => (new SkillsMessage(1, [Item])), dispatch);
}

export function Settings_skills(skills, dispatch) {
    let children, elems;
    const xs_1 = [(children = ofArray([Settings_farming(skills, dispatch), Settings_foraging(skills, dispatch)]), createElement("div", {
        children: reactApi.Children.toArray(Array.from(children)),
    })), createElement("div", createObj(ofArray([["className", "settings-group"], (elems = [checkbox("Ignore Skill Level Unlocks", skills.IgnoreSkillLevelRequirements, (arg) => {
        dispatch(new SkillsMessage(3, [arg]));
    }), checkbox("Ignore Profession Conflicts", skills.IgnoreProfessionConflicts, (arg_1) => {
        dispatch(new SkillsMessage(4, [arg_1]));
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))];
    return react.createElement(react.Fragment, {}, ...xs_1);
}

export function Settings_multipliers(multipliers, dispatch) {
    const xs = [labeled("Profit Margin", options(4 + "em", (margin) => ((margin === 1) ? "Normal" : percent(margin)), toArray(rangeDouble(1, -0.25, 0.25)), multipliers.ProfitMargin, (arg) => {
        dispatch(new MultipliersMessage(0, [arg]));
    })), checkboxWith(Icon_bearsKnowledge, multipliers.BearsKnowledge, (arg_1) => {
        dispatch(new MultipliersMessage(1, [arg_1]));
    }), checkbox("Apply Tiller to Foraged Grapes and Blackberries", multipliers.TillerForForagedFruit, (arg_2) => {
        dispatch(new MultipliersMessage(2, [arg_2]));
    })];
    return react.createElement(react.Fragment, {}, ...xs);
}

export function Settings_profitSettings(profit, dispatch) {
    let elems;
    return createElement("div", createObj(ofArray([["className", "settings-column"], (elems = [labeled("Seed Strategy", options(5 + "em", getCaseName, map((x_1) => makeUnion(x_1, []), getUnionCases(SeedStrategy_$reflection())), profit.SeedStrategy, (arg) => {
        dispatch(new ProfitMessage(0, [arg]));
    })), payForFertilizerSettings(profit, dispatch)], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function Settings_priceSettings(game, profit, dispatch) {
    let elems_1, elems;
    return createElement("div", createObj(ofArray([["className", "settings-columns"], (elems_1 = [Settings_profitSettings(profit, (arg) => {
        dispatch(new SettingsMessage(1, [arg]));
    }), createElement("div", createObj(ofArray([["className", "settings-column"], (elems = [Settings_multipliers(game.Multipliers, (arg_2) => {
        dispatch(new SettingsMessage(0, [new GameVariablesMessage(4, [arg_2])]));
    }), checkbox("Joja Membership", game.JojaMembership, (arg_4) => {
        dispatch(new SettingsMessage(0, [new GameVariablesMessage(6, [arg_4])]));
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function Settings_cropSettings(irrigated, settings, settingsDispatch) {
    let elems;
    const dispatch = (arg) => {
        settingsDispatch(new GameVariablesMessage(5, [arg]));
    };
    return createElement("div", createObj(ofArray([["className", "settings-block"], (elems = [floatWithRange("Average Giant Crop Orientations Per Tile", 4 + "em", 0.001, 0, 9, settings.GiantCropOrientationsPerTile, (arg_1) => {
        dispatch(new CropAmountMessage(2, [arg_1]));
    }), labeled("Shaving Enchantment", options(4 + "em", (arg_2) => Option_defaultOrMap("None", ToolLevelModule_name, arg_2), insertAt(0, undefined, map((Value) => Value, getEnumValues(enum_type("StardewValleyStonks.ToolLevel", int32_type, [["Normal", 0], ["Copper", 1], ["Steel", 2], ["Gold", 3], ["Iridium", 4]])))), settings.ShavingToolLevel, (arg_3) => {
        dispatch(new CropAmountMessage(3, [arg_3]));
    })), labelWith("label-text", Icon_luckBuff, natWith(2 + "em", undefined, 1499, settings.LuckBuff, (arg_4) => {
        dispatch(new CropAmountMessage(1, [arg_4]));
    })), checkboxWith(Icon_specialCharm, settings.SpecialCharm, (arg_5) => {
        dispatch(new CropAmountMessage(0, [arg_5]));
    }), checkbox("Irrigated", irrigated, (arg_6) => {
        settingsDispatch(new GameVariablesMessage(7, [arg_6]));
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function Settings_mods(qualityArtisanProducts, dispatch) {
    let elems;
    return createElement("div", createObj(ofArray([["className", "settings-block"], (elems = [checkbox("Quality Artisan Products", qualityArtisanProducts, (arg) => {
        dispatch(new GameVariablesMessage(8, [arg]));
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function Settings_tab(openDetails, game, profit, dispatch) {
    let elems;
    const uiDispatch = (arg) => {
        dispatch(new StateMessage(1, [arg]));
    };
    const settingsDispatch = (arg_1) => {
        dispatch(new StateMessage(0, [arg_1]));
    };
    const dispatch_1 = (arg_2) => {
        settingsDispatch(new SettingsMessage(0, [arg_2]));
    };
    const xs_1 = [createElement("div", createObj(ofArray([["className", "settings-group"], (elems = [Settings_dates(game.StartDate, game.EndDate, dispatch_1), labeled("Location", options(6 + "em", getCaseName, map((x_1) => makeUnion(x_1, []), getUnionCases(Location_$reflection())), game.Location, (arg_3) => {
        dispatch_1(new GameVariablesMessage(2, [arg_3]));
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), detailsSection(openDetails, new OpenDetails(6, []), "Skills", Settings_skills(game.Skills, (arg_5) => {
        dispatch_1(new GameVariablesMessage(3, [arg_5]));
    }), uiDispatch), detailsSection(openDetails, new OpenDetails(7, []), "Price Settings", Settings_priceSettings(game, profit, settingsDispatch), uiDispatch), detailsSection(openDetails, new OpenDetails(8, []), "Crop Settings", Settings_cropSettings(game.Irrigated, game.CropAmount, dispatch_1), uiDispatch), detailsSection(openDetails, new OpenDetails(9, []), "Mods", Settings_mods(game.QualityArtisanProducts, dispatch_1), uiDispatch)];
    return react.createElement(react.Fragment, {}, ...xs_1);
}

export function LoadSave_viewPreset(preset) {
    let elems;
    return createElement("div", createObj(ofArray([["className", "preset"], (elems = toList(delay(() => append(singleton(createElement("span", {
        children: [preset.Name],
    })), delay(() => {
        if (preset.UniqueId != null) {
            const startDate = preset.Settings.Game.StartDate;
            return singleton(createElement("span", {
                children: [`${SeasonModule_name(startDate.Season)} ${startDate.Day}`],
            }));
        }
        else {
            return empty();
        }
    })))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function LoadSave_saveFileInput(save, setSave) {
    let elems;
    return createElement("div", createObj(ofArray([["className", "file-input"], (elems = toList(delay(() => {
        let children_2, children;
        const loadFile = (file) => {
            file.text().then((text) => setSave([file.name, loadSaveGame(text)]));
        };
        return append(singleton((children_2 = ofArray([(children = ofArray(["Choose Save File", createElement("input", {
            type: "file",
            onChange: (ev) => {
                const files = ev.target.files;
                if (!(files == null) && (files.length > 0)) {
                    loadFile(files.item(0));
                }
            },
            autoFocus: true,
        })]), createElement("label", {
            children: reactApi.Children.toArray(Array.from(children)),
        })), ofOption(LoadSave_viewPreset, save)]), createElement("div", {
            children: reactApi.Children.toArray(Array.from(children_2)),
        }))), delay(() => singleton(createElement("div", {
            "aria-hidden": true,
            onDragOver: (event) => {
                handleEvent(event);
            },
            onDrop: (e) => {
                handleEvent(e);
                if (e.dataTransfer.files.length > 0) {
                    loadFile(e.dataTransfer.files[0]);
                }
            },
            children: "or drag the file here",
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function LoadSave_saveFileMessages(presets, save) {
    return ofOption((tupledArg) => {
        let elems;
        const fileName = tupledArg[0];
        return createElement("ul", createObj(ofArray([["className", "messages"], (elems = toList(delay(() => append((fileName !== "SaveGameInfo") ? singleton(createElement("li", {
            children: [Icon_warning(`It appears you have chosen a file named "${fileName}". Please choose the file named "SaveGameInfo".`)],
        })) : empty(), delay(() => {
            const matchValue = tupledArg[1];
            if (matchValue != null) {
                const missing = matchValue[1];
                return append(exists((uniqueId) => exists_1((preset_2) => PresetModule_hasId(uniqueId, preset_2), presets), toArray_1(matchValue[0].UniqueId)) ? singleton(createElement("li", {
                    children: [Icon_warning("This save game has been previously imported. Clicking \"Ok\" will update/overwrite the existing preset.")],
                })) : empty(), delay(() => {
                    let xs, children_1;
                    return (missing.length > 0) ? singleton(createElement("li", {
                        children: [Icon_warningWith((xs = [createElement("span", {
                            children: ["Warning: failed to load the following data from the save game:"],
                        }), (children_1 = map((children) => createElement("li", {
                            children: [children],
                        }), missing), createElement("ul", {
                            children: reactApi.Children.toArray(Array.from(children_1)),
                        })), createElement("span", {
                            children: ["Click \"Ok\" if you want to continue anyways."],
                        })], react.createElement(react.Fragment, {}, ...xs)))],
                    })) : empty();
                }));
            }
            else {
                return singleton(createElement("li", {
                    children: [Icon_error("Failed to load the save game.")],
                }));
            }
        })))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }, save);
}

export function LoadSave_importSave(presets, dispatch) {
    return toggleEditWith("Import Save", "Import Save Game", undefined, (arg_2) => {
        iterate((arg_1) => {
            dispatch(new PresetsMessage(0, [arg_1[0]]));
        }, toArray_1(bind((tuple) => tuple[1], arg_2)));
    }, (_arg, save, setSave) => {
        let children, str_1;
        const xs_1 = [(children = ofArray([(str_1 = "\n              Please provide the \"SaveGameInfo\" file for the save you want to import.\n              Instructions for where to find this file can be found on the\n            ", str_1), createElement("a", {
            href: "https://stardewvalleywiki.com/Saves#Save_format",
            target: "_blank",
            rel: "noopener noreferrer",
            children: "Stardew Valley Wiki",
        }), "."]), createElement("p", {
            children: reactApi.Children.toArray(Array.from(children)),
        })), LoadSave_saveFileInput(map_2((tuple_3) => tuple_3[0], bind((tuple_2) => tuple_2[1], save)), setSave), LoadSave_saveFileMessages(presets, save)];
        return react.createElement(react.Fragment, {}, ...xs_1);
    });
}

export function LoadSave_nuclearReset(dispatch) {
    let children;
    return confirmAction("Nuclear Reset", Icon_warning("Nuclear Reset"), () => {
        dispatch(new AppMessage(3, []));
    }, (children = ofArray(["Warning: This will reset Stardew Valley Stonks to its default settings, ", createElement("strong", {
        children: ["deleting"],
    }), " all custom presets in the process."]), createElement("p", {
        children: reactApi.Children.toArray(Array.from(children)),
    })));
}

export function LoadSave_presetList(presets, loadDispatch, saveDispatch) {
    const presets_1 = isEmpty(presets) ? singleton_1(createElement("li", {
        className: "empty",
        "aria-hidden": true,
        children: "No presets...",
    })) : mapIndexed((i, preset) => {
        let children;
        const children_2 = ofArray([LoadSave_viewPreset(preset), (children = ofArray([createElement("button", {
            className: "button",
            onClick: (_arg) => {
                loadDispatch(preset.Settings);
            },
            children: "Load",
        }), toggleEditWith("Edit", `Rename Preset '${preset.Name}'`, preset.Name, (arg) => {
            let tupledArg;
            saveDispatch((tupledArg = [i, arg], new PresetsMessage(2, [tupledArg[0], tupledArg[1]])));
        }, (_arg_1, name_4, setName) => labeled("Name", text_2(name_4, setName))), createElement("button", {
            className: "button",
            onClick: (_arg_2) => {
                saveDispatch(new PresetsMessage(3, [i]));
            },
            children: "Delete",
        })]), createElement("div", {
            children: reactApi.Children.toArray(Array.from(children)),
        }))]);
        return createElement("li", {
            children: reactApi.Children.toArray(Array.from(children_2)),
        });
    }, presets);
    const children_6 = ofArray([createElement("h1", {
        children: ["Presets"],
    }), createElement("ul", {
        children: reactApi.Children.toArray(Array.from(presets_1)),
    })]);
    return createElement("section", {
        children: reactApi.Children.toArray(Array.from(children_6)),
    });
}

export function LoadSave_tab(presets, settings, dispatch) {
    let children, children_2;
    const saveDispatch = (arg) => {
        dispatch(new AppMessage(1, [arg]));
    };
    const loadDispatch = (arg_2) => {
        dispatch(new AppMessage(0, [new StateMessage(2, [arg_2])]));
    };
    const xs_1 = [LoadSave_presetList(presets, loadDispatch, saveDispatch), (children = ofArray([toggleEditWith("Save Current Settings", "New Preset", "Untitled Preset", (name) => {
        saveDispatch(new PresetsMessage(1, [name, settings]));
    }, (_arg, name_1, setName) => labeled("Name", text_2(name_1, setName))), LoadSave_importSave(presets, saveDispatch)]), createElement("div", {
        children: reactApi.Children.toArray(Array.from(children)),
    })), (children_2 = ofArray([createElement("button", {
        className: "button",
        onClick: (_arg_1) => {
            loadDispatch(defaultSettings);
        },
        children: "Reset Settings",
    }), LoadSave_nuclearReset(dispatch)]), createElement("div", {
        children: reactApi.Children.toArray(Array.from(children_2)),
    }))];
    return react.createElement(react.Fragment, {}, ...xs_1);
}

export function section(app, dispatch) {
    let elems;
    const dispatch_1 = (arg) => {
        dispatch(new AppMessage(0, [arg]));
    };
    const patternInput = app.State;
    const ui = patternInput[1];
    const settings = patternInput[0];
    return createElement("section", createObj(ofArray([["id", "settings"], (elems = [createElement(Tabs_1, {
        Current: ui.SettingsTab,
        Dispatch: (arg_2) => {
            dispatch_1(new StateMessage(1, [new UIMessage(3, [arg_2])]));
        },
        Label: "Settings",
        Panel: (_arg) => {
            switch (_arg.tag) {
                case 1:
                    return Fertilizers_tab(app, dispatch_1);
                case 2:
                    return Settings_tab(ui.OpenDetails, settings.Game, settings.Profit, dispatch_1);
                case 3:
                    return LoadSave_tab(app.Presets, settings, dispatch);
                default:
                    return Crops_tab(app, dispatch_1);
            }
        },
        Tabs: map((x) => makeUnion(x, []), getUnionCases(SettingsTab_$reflection())),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

//# sourceMappingURL=Settings.js.map
